import {
  SaveMedicalHistoryRequestProto,
  SaveMedicalHistoryResponseProto,
} from "@noom/noom-contracts/noom_contracts/healthcare/service/healthcare/external_health_records_service";
import { Api } from "@noom/noomscape";

import axios, { AxiosResponse } from "axios";

Api.register(
  "healthRecords.saveMedicalHistory",
  async ({
    accessCode,
    accessToken,
    body,
  }: SaveMedicalHistoryRequestProto & { accessToken: string }) => {
    const response: AxiosResponse<SaveMedicalHistoryResponseProto> =
      await axios({
        baseURL: window.ENV.HEALTHCARE_SERVER_URL,
        data: body,
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        method: "POST",
        url: `/externalHealthData/${accessCode}/medicalHistory`,
        urlWithPathParams: "/externalHealthData/{accessCode}/medicalHistory",
      });

    return response.data;
  },
);
